// extracted by mini-css-extract-plugin
var _1 = "FilePreview-moduledisabled__IV1yP";
var _2 = "FilePreview-moduleerror__z5Khz";
var _3 = "FilePreview-moduleerrorIconBlock__DprJ6";
var _4 = "FilePreview-moduleerrorText__r722D";
var _5 = "FilePreview-modulefile__mkfo5";
var _6 = "FilePreview-modulefileIcon__iLkiH FileIconPreview-moduleicon__wDz2Z FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _7 = "FilePreview-modulefileInfo__MgWZk";
var _8 = "FilePreview-moduleimageOverlay__lxm0H FilePreviewOverlay-moduleFilePreviewOverlay__vJvIV";
var _9 = "FilePreview-moduleloader__sLlch";
var _a = "FilePreview-moduleloaderActive__BLf78";
var _b = "FilePreview-moduleloaderBox__iiUqQ";
var _c = "FilePreview-moduleloading__vEsvl";
var _d = "FilePreview-modulesize__qUfth";
var _e = "FilePreview-moduleskeleton___AwWB Skeleton-moduleSkeleton__Mlrfv";
var _f = "FilePreview-moduletext__DF9j8";
export { _1 as "disabled", _2 as "error", _3 as "errorIconBlock", _4 as "errorText", _5 as "file", _6 as "fileIcon", _7 as "fileInfo", _8 as "imageOverlay", _9 as "loader", _a as "loaderActive", _b as "loaderBox", _c as "loading", _d as "size", _e as "skeleton", _f as "text" }
